import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

/** Intentional empty — not an error dump — plan/27 / plan/35. */
export function EmptyState(props: {
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "rounded-[var(--radius-xl)] border border-dashed border-[var(--color-border)] bg-[var(--color-card)]/55 px-5 py-14 text-center animate-[fadeIn_280ms_ease-out]",
        props.className,
      )}
    >
      <p className="m-0 font-[family-name:var(--font-display)] text-lg font-semibold tracking-tight text-[var(--color-foreground)]">
        {props.title}
      </p>
      {props.description ? (
        <p className="mx-auto mt-2 max-w-sm text-sm leading-relaxed text-[var(--color-muted)]">
          {props.description}
        </p>
      ) : null}
      {props.action ? (
        <div className="mt-6 flex justify-center">{props.action}</div>
      ) : null}
    </div>
  );
}
